// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"ActivityCategoryContextMenu__menuWrapper___2Joc5","menuItem":"ActivityCategoryContextMenu__menuItem___JywZX"};